import { confirmable, createConfirmation } from 'react-confirm';

import { IModalAlertProps, ModalAlert } from './ModalAlert';

export function confirmAlert(options: IModalAlertProps) {
  const defaultConfirmation = createConfirmation(confirmable(ModalAlert));
  return defaultConfirmation(options);
}
